export default {
  time: {
    hhmmss: {
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric'
    },
    hhmm: {
      hour: 'numeric',
      minute: 'numeric'
    }
  },
  date: {
    fullDateLong: {
      month: 'long',
      day: 'numeric',
      year: 'numeric'
    },
    fullDateShort: {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    },
    fullDateShortUTC: {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      timeZone: 'UTC'
    },
    fullDateWithDayOfWeek: {
      weekday: 'short',
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    },
    mmddyy: {
      month: '2-digit',
      day: '2-digit',
      year: '2-digit'
    },
    mmddyyyy: {
      month: '2-digit',
      day: '2-digit',
      year: 'numeric'
    },
    monthDay: {
      month: 'short',
      day: 'numeric'
    },
    fullMonthDay: {
      month: 'long',
      day: 'numeric'
    },
    shortMonthYear: {
      month: 'short',
      year: 'numeric'
    },
    longMonthYear: {
      month: 'long',
      year: 'numeric'
    },
    hhmmss: {
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric'
    }
  },
  number: {
    USD: {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }
  }
};